import { Route, Switch } from 'platform-components/src/components/router/router';
import { withRouterPath } from 'platform-components/hocs';
import PropTypes from 'prop-types';
import React from 'react';
import { Helmet } from 'react-helmet';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';

import ChangesNotification from 'common.components/changes-notification/changes-notification';
import * as commonClassActions from 'common.components/classes/actions';
import * as studentsActions from 'common.components/students/actions';
import { getNewStudent } from 'common.components/students/selectors';
import { getSavedOrFirstTeamId } from 'common.components/user/selectors';
import { actions as coursesActions } from 'store/courses/actions';
import { studentPropTypes } from 'utils/data-prop-types';

import ClassHeader from '../class-header/class-header';
import { ExamsResults } from '../exams-results/exams-results';

import { TeamInvitationContainer } from './__invitation/class__invitation-container';
import ClassView from './__view/class__view';
import * as classActions from './actions';
import { getCreatedTeamId, getShouldRedirect } from './selectors';

import './class.scss';

export class Class extends React.Component {
    static propTypes = {
        cancelAddingNewStudent: PropTypes.func.isRequired,
        savedOrFirstTeamId: PropTypes.number,
        teamId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        getClassRequest: PropTypes.func.isRequired,
        getCoursesByTeamRequest: PropTypes.func.isRequired,
        getRouterPath: PropTypes.func.isRequired,
        handleRedirectToCreatedClass: PropTypes.func.isRequired,
        history: PropTypes.object,
        currentTeamId: PropTypes.number,
        newStudent: studentPropTypes,
        setShouldRedirect: PropTypes.func.isRequired,
        shouldRedirect: PropTypes.bool,
        intl: PropTypes.object.isRequired,
        createdTeamId: PropTypes.number,
    };

    static contextTypes = {
        staticUrls: PropTypes.object.isRequired,
    };

    state = {
        opened: false,
    };

    componentDidMount() {
        const { teamId, getClassRequest, getCoursesByTeamRequest, shouldRedirect, createdTeamId } = this.props;

        if (teamId) {
            getClassRequest(teamId);

            getCoursesByTeamRequest({ teamId });
        } else {
            this.redirectToFirstClass();
        }

        if (shouldRedirect) {
            this.redirectToCreatedClass(createdTeamId);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { teamId: nextTeamId, newStudent: nextNewStudent, shouldRedirect, createdTeamId } = nextProps;

        const { cancelAddingNewStudent, teamId, getClassRequest } = this.props;

        if (teamId !== nextTeamId) {
            if (nextNewStudent !== null) {
                cancelAddingNewStudent();
            }

            if (nextTeamId) {
                getClassRequest(nextTeamId);
            }
        }

        if (shouldRedirect) {
            this.redirectToCreatedClass(createdTeamId);
        }
    }

    redirectToFirstClass = () => {
        const { getRouterPath, history, savedOrFirstTeamId } = this.props;

        if (savedOrFirstTeamId) {
            const { staticUrls } = this.context;

            history.push(
                `${getRouterPath(staticUrls.labClassStudents, { classId: savedOrFirstTeamId })}${
                    history.location.search
                }`
            );
        }
    };

    redirectToCreatedClass = (createdTeamId) => {
        const { getRouterPath, history, setShouldRedirect, handleRedirectToCreatedClass } = this.props;

        if (createdTeamId) {
            const { staticUrls } = this.context;

            setShouldRedirect(false, null);

            history.push(
                `${getRouterPath(staticUrls.labClassStudents, { classId: createdTeamId })}${history.location.search}`
            );

            handleRedirectToCreatedClass(createdTeamId);
        }
    };

    render() {
        const { staticUrls } = this.context;
        const { teamId, intl } = this.props;

        return (
            <React.Fragment>
                <Helmet title={intl.formatMessage({ id: 'myTeamsPage.title' })} />
                <ClassHeader classId={teamId} />
                <ChangesNotification />
                <div className="class">
                    <Switch>
                        <Route component={ClassView} exact path={staticUrls.labClasses} />
                        <Route component={TeamInvitationContainer} exact path={staticUrls.labClassPrint} />
                        <Route component={TeamInvitationContainer} exact path={staticUrls.labClassPrintStudent} />
                        <Route component={ExamsResults} exact path={staticUrls.labClassExamsResults} />
                        <Route component={ClassView} path={staticUrls.labClass} />
                    </Switch>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (storeState, ownProps) => {
    const {
        match: {
            params: { classId },
        },
    } = ownProps;

    return {
        teamId: classId,
        savedOrFirstTeamId: getSavedOrFirstTeamId(storeState),
        newStudent: getNewStudent(storeState),
        shouldRedirect: getShouldRedirect(storeState),
        createdTeamId: getCreatedTeamId(storeState),
    };
};

const mapDispatchToProps = (dispatch) => {
    const { setShouldRedirect, handleRedirectToCreatedClass } = classActions;
    const { getTeam } = commonClassActions;
    const { cancelAddingNewStudent } = studentsActions;
    const { getCoursesByTeamRequest } = coursesActions;

    return bindActionCreators(
        {
            cancelAddingNewStudent,
            getClassRequest: getTeam,
            setShouldRedirect,
            handleRedirectToCreatedClass,
            getCoursesByTeamRequest,
        },
        dispatch
    );
};

export default compose(withRouterPath, injectIntl, connect(mapStateToProps, mapDispatchToProps))(Class);
